import React, { useMemo, useEffect, useCallback } from 'react';
import { Field, useFormikContext } from 'formik';
import dayjs from 'dayjs';

import { getDynVal, getIndex } from '../../utils/DynHelper';
import { DatePickerUI, FormLabelUI } from '../Interface';

const DynDateInput = ({ name, disabled, selectedValues, showLabel, fieldData }, ...props) => {
  const { property } = fieldData;
  const { values, setFieldValue } = useFormikContext();

  const dynVal = useMemo(
    () => getDynVal(selectedValues.dynamicProperties, name),
    [selectedValues.dynamicProperties, name]
  );

  useEffect(() => {
    const setterVal = dynVal?.dateVal ?? null;

    setFieldValue(name, setterVal ? dayjs(setterVal) : null);
  }, [dynVal, name, setFieldValue]);

  const handleChange = useCallback(
    (e) => {
      const value = e && e.isValid() ? dayjs(e).startOf('day').add(12, 'hour').toISOString() : null;
      setFieldValue(name, value);
    },
    [name, setFieldValue]
  );
  return (
    <Field
      name={name}
      as={DatePickerUI}
      fullWidth
      variant="standard"
      disabled={disabled}
      value={dayjs(values.dynamicFields?.[getIndex(name)])}
      onChange={handleChange}
      label={showLabel ? <FormLabelUI text={property?.name} /> : undefined}
      {...props}
    />
  );
};

export default DynDateInput;
